import { Stack, Text } from '@fluentui/react'
import { Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { ConversationsOverTimeResponse } from '../../api/models'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

type ConversationsTimelineProps = {
  data: ConversationsOverTimeResponse | null
}

const cardStyle = {
  root: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: 1,
  },
}

const ConversationsTimeline = ({ data }: ConversationsTimelineProps) => {
  if (!data) return null

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Conversations',
        data: data.counts,
        borderColor: '#2B3A67',
        backgroundColor: 'rgba(43, 58, 103, 0.1)',
        fill: true,
        tension: 0.3,
        pointRadius: 3,
        pointHoverRadius: 6,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  }

  return (
    <Stack styles={cardStyle} tokens={{ childrenGap: 12 }}>
      <Text variant="mediumPlus" styles={{ root: { fontWeight: 600, color: '#605e5c' } }}>
        Conversations Over Time
      </Text>
      {data.labels.length > 0 ? (
        <div style={{ height: 300 }}>
          <Line data={chartData} options={options} />
        </div>
      ) : (
        <Text styles={{ root: { color: '#a19f9d', textAlign: 'center', padding: 40 } }}>
          No conversation data available for this period.
        </Text>
      )}
    </Stack>
  )
}

export default ConversationsTimeline
